import { Box, IconButton, Stack, Typography } from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import StarIcon from "@mui/icons-material/Star";
import { formatWeightWithUnits, UomConversion } from "../../../utils";

const IngredientItem = ({ item, type, level = 0 }) => {
  const [expanded, setExpanded] = useState(null); // Expand the first level by default
  const hasSubItems = item.type === "recipe";
  const isMainIngredient = item?.pivot?.is_main_ingredient; // Assuming this flag exists in your data
  const primaryLevel = level === 0;
  const isNestedLevel = level > 1;

  const handleExpand = () => setExpanded(!expanded);

  return (
    <Stack
      sx={{
        borderRadius: primaryLevel ? "6px" : "none",
        border: primaryLevel ? "1px solid" : "none",
        display: "flex",
        flexDirection: "column",
        borderColor: "divider",
        minHeight: primaryLevel ? "40px" : "32px",
        justifyContent: "center",
        ml: isNestedLevel ? `${level * 4}px` : 0,
      }}
    >
      <Box
        sx={{
          backgroundColor: primaryLevel ? "#F8FAFC" : "#FFFFFF",
          display: "flex",
          flexDirection: "column",
          minHeight: primaryLevel ? "40px" : "32px",
          justifyContent: "center",
          p: "0px 8px",
          borderRadius: expanded ? "6px 6px 0px 0px " : "6px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "6px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              minWidth: type === "preview" ? "170px" : "300px",
              gap: "6px",
              flex: 1,
              width: "80%",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: primaryLevel ? 600 : 400 }}
            >
              {item.name || item.ingredient_name}
            </Typography>

            <IconButton
              size="small"
              onClick={handleExpand}
              sx={{ display: hasSubItems ? "" : "none" }}
            >
              <ExpandMoreIcon
                sx={{
                  transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "0.3s all",
                }}
                fontSize="small"
              />
            </IconButton>

            <StarIcon
              fontSize="18px"
              color="primary"
              sx={{ display: isMainIngredient ? "" : "none" }}
            />
          </Box>
          <Typography
            fontWeight={600}
            fontSize="14px"
            whiteSpace="nowrap"
            width="20%"
            textAlign="right"
          >
            {UomConversion(item)}
          </Typography>
        </Box>
      </Box>
      {hasSubItems && expanded && (
        <Box sx={{ borderTop: isNestedLevel ? 0 : 1, borderColor: "divider" }}>
          {item.ingredient.map((subItem, index) => (
            <IngredientItem
              key={index}
              item={subItem}
              level={level + 1}
              type={type}
            />
          ))}
        </Box>
      )}
    </Stack>
  );
};

const BatchIngredientList = ({ currentBatch, globalData, type }) => {
  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#E6EEF7",
          padding: "8px",
          fontWeight: 600,
        }}
      >
        <Typography fontWeight={600} fontSize={"12px"}>
          Ingredients
        </Typography>
        <Typography
          fontWeight={600}
          fontSize={"12px"}
          sx={{ textAlign: "right" }}
        >
          Quantity
        </Typography>
      </Box>

      {/* Ingredient List */}
      <Stack gap="8px" my="8px">
        {currentBatch?.ingredients?.map((ingredient, index) => (
          <IngredientItem key={index} item={ingredient} type={type} />
        ))}
      </Stack>
      {/* Total Weight */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          backgroundColor: "#E6EEF7",
          padding: "10px 8px",
          fontWeight: 600,
          height: "40px",
          alignItems: "center",
        }}
      >
        <Typography fontWeight={600} fontSize="14px">
          Total Weight
        </Typography>
        <Typography fontWeight={600} fontSize="14px">
          {formatWeightWithUnits(
            currentBatch?.total_weight,
            "kg",
            globalData?.all_Units
          )}
        </Typography>
      </Box>
    </Box>
  );
};

export default BatchIngredientList;
